import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-endsession/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    FETCH_END_SESSION = "one-state-endsession/fetch"
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Active Problems
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchEndSessionEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            servers,
            epicendpoints: {
                endsession, apitoken
            },
            uisettings: {
                dashboardapiconfig: {
                    endsession: endsessionApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.FETCH_END_SESSION),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let payload: any = action.payload;
                const postEndSession = (endsessionrequest: any) => {

                    if (endsessionrequest) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let data: any = {}
                        if (endsessionrequest?.key) {
                            data = {
                                key: endsessionrequest.key
                            }
                        }
                        else if (endsessionrequest?.media_address) {
                            data = {
                                media_address: endsessionrequest.media_address
                            }
                        }
                        let responseFromPost;
                        if (finesse_proxy_service) {
                            responseFromPost = InvokeFinesseProxy(endsession, data, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            responseFromPost = server.post({
                                headers: headers,
                                path: endsession,
                                data: data,
                            })
                                .then((responseforap: any) => responseforap)
                                .catch((endsessionerror: any) => {
                                    log.error(
                                        "ccw-gadget,endsession-epic",
                                        "endsession-epic", {
                                        endsessionerror
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "SetSession",
                                        type: "error",
                                        status: endsessionerror?.status,
                                        erroritems: endsessionerror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,activeproblems-epic",
                                "activeproblems-epic response", {
                                responseFromPost
                            });
                        }
                        return from(responseFromPost)
                    } else {
                        return from([]);
                    }
                }
                //Calling getReqeust function here
                //the reason is we need to use pipe function.
                if (!endsessionApi) return []
                return postEndSession(payload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.activeproblems)
                            ];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "2034" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                  else if(contact_center_type==="intermedia"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                  } 
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = payload?.key
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                disp.meta05 = 'Failed to delete the session';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "2033" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                  else if(contact_center_type==="intermedia"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                  } 
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = payload?.key;
                                disp.meta03 = "Session deleted successfully"
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearEndSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, setsessiom-epic",
            "clear-setsessiom-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED,PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);